import ResourceService from './resource.service'

class CityService extends ResourceService {
  static get resource() {
    return 'city'
  }
}

export default CityService
